import styled from "@emotion/styled";
import { Link } from "react-router-dom";

const StyledLink = (props) => {
  const { typo, children, config, color, toProp, href, ...rest } = props;

  const to = toProp || href;

  const colorProp = color || "#006E3D";

  return (
    <StyledLinkBase
      to={to}
      config={config}
      color={colorProp}
      {...rest}
      className="styled-link"
    >
      <span className="children-txt">{children}</span>
    </StyledLinkBase>
  );
};

const StyledLinkBase = styled(Link)`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: ${(props) => props.color};
  gap: 8px;

  .children-txt {
    font-family: "Roboto";
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export default StyledLink;
